export const GROUP_NAME_PATTERN = /^[a-zA-Z0-9_-]{1,128}$/;
export const STREAM_NAME_PATTERN = /^[a-zA-Z0-9_-]{0,128}$/;
